interface ItemCategory {
    id: number;
    name: string;
    parent: number | null;
    selectable: boolean;
}

const EmptyCategory: ItemCategory = {
    id: 0,
    name: '',
    parent: null,
    selectable: false
};

export { EmptyCategory };

export default ItemCategory;
